import { useMemo } from 'react';

import { useSite } from '../contexts/SiteContext';

export function useMicromags(initialMicromags) {
    const { isKiosk = null } = useSite();

    const micromags = useMemo(() => {
        if (initialMicromags === null) {
            return null;
        }

        const { story: shareStory = null } = [...initialMicromags].find(
            (it) => it.slug === 'ecran-de-partage',
        ) || { story: null };

        const { components: shareComponents = [], medias: shareMedias = [] } = shareStory || {};
        const [shareScreen = null] = shareComponents || [];
        const { footer = null } = shareScreen || {};
        const finalShareScreen = !isKiosk
            ? {
                  ...shareScreen,
                  footer: {
                      ...footer,
                      callToAction: null,
                  },
              }
            : null;
        const items = [...initialMicromags]
            .filter((it) => it.slug !== 'ecran-de-partage')
            .map((item) => {
                const {
                    components: itemComponents = [],
                    medias: itemMedias = [],
                    ...restOfStory
                } = item.story || { story: null };
                return {
                    ...item,
                    story: {
                        components:
                            finalShareScreen !== null
                                ? [...itemComponents, finalShareScreen]
                                : itemComponents,
                        medias:
                            finalShareScreen !== null
                                ? { ...itemMedias, ...shareMedias }
                                : itemMedias,
                        ...restOfStory,
                    },
                };
            });

        for (let i = items.length - 1; i > 0; i -= 1) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]];
        }
        return items;
    }, [initialMicromags]);

    return micromags;
}

export default useMicromags;
